var _path, _line, _line2, _line3, _line4, _mask, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankTransfer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 68,
    viewBox: "0 0 116 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.2897 18.394V8.02516C95.2897 4.70164 92.5881 2.0113 89.2646 2.02521L7.97489 2.36533C4.67101 2.37916 2 5.06137 2 8.36528V54.7452C2 58.0589 4.68629 60.7452 8 60.7452H65.4292",
    stroke: "#233F91",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14.0027,
    y1: 17.5771,
    x2: 52.4506,
    y2: 17.5771,
    stroke: "#233F91",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 14.0027,
    y1: 46.657,
    x2: 33.1291,
    y2: 46.657,
    stroke: "#233F91",
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 14.0027,
    y1: 27.1403,
    x2: 70.6011,
    y2: 27.1403,
    stroke: "#233F91",
    strokeWidth: 3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 14.0027,
    y1: 36.8986,
    x2: 70.6011,
    y2: 36.8986,
    stroke: "#233F91",
    strokeWidth: 3
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-1_2_22",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.2869 23.4168C99.0665 22.6343 100.333 22.632 101.115 23.4116L107.916 30.1871C108.699 30.9667 108.701 32.233 107.922 33.0155L82.8661 58.1646L73.2315 48.5659L98.2869 23.4168Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2869 23.4168C99.0665 22.6343 100.333 22.632 101.115 23.4116L107.916 30.1871C108.699 30.9667 108.701 32.233 107.922 33.0155L82.8661 58.1646L73.2315 48.5659L98.2869 23.4168Z",
    fill: "#233F91",
    stroke: "#233F91",
    strokeWidth: 13.6,
    mask: "url(#path-6-inside-1_2_22)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0019 48.9345C73.2016 48.1928 74.1282 47.9439 74.6727 48.4855L82.9282 56.6975C83.4745 57.241 83.2267 58.1722 82.4824 58.3722L71.1991 61.4039C70.4548 61.6039 69.7736 60.9223 69.974 60.1781L73.0019 48.9345Z",
    fill: "#233F91"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 76.6513,
    y: 47.8622,
    width: 25.2727,
    height: 9.93767,
    rx: 1,
    transform: "rotate(-45.5814 76.6513 47.8622)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankTransfer);
export default __webpack_public_path__ + "static/media/bankTransfer.c8a37d1e20e52717f71802e3aa4275fc.svg";
export { ForwardRef as ReactComponent };